import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import WrappedAuthContainer from './WrappedAuthContainer';
import { useRouteParams } from '../../utils/legacyUtils';

const AuthController = (props) => {
  const {
    Analytics,
    AutomationMode,
    callingCode,
    ResyAmexConfig,
  } = props;
  const $routeParamsShim = useRouteParams();

  return (
    <WrappedAuthContainer
      Analytics={Analytics}
      AutomationMode={AutomationMode}
      callingCode={callingCode}
      $routeParams={$routeParamsShim}
      ResyAmexConfig={ResyAmexConfig}
    />
  );
};

AuthController.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  AutomationMode: PropTypes.bool.isRequired,
  callingCode: PropTypes.string.isRequired,
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = ({ ipdata, resyConfig }) => {
  const { countryCode } = ipdata;
  const { config } = resyConfig;
  let callingCode = null;
  if (config && countryCode) {
    const { country_codes: countries } = config;
    const [country] = countries.filter(
      (value) => (countryCode === value.iso3166)
    );
    callingCode = country.code;
  }
  return { callingCode };
};

export { AuthController as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AuthController);
